import api from 'services/api'
import {
  LOGIN,
  REGISTER,
  FORGOT_PASSWORD,
  VERIFY_RESET_PASSWORD_OTP,
  RESET_PASSWORD,
  LOGOUT,
  GET_PROFILE_DETAIL,
  UPDATE_PROFILE,
  UPDATE_PASSWORD,
} from '../endpoints'

export const loginValidate = async (values) => await api.post(LOGIN, values)
export const signup = async (values) => await api.post(REGISTER, values)
export const forgotPasswordEmail = async (email) => await api.post(FORGOT_PASSWORD, {email})
export const verifyOTP = async (values) => await api.post(VERIFY_RESET_PASSWORD_OTP, values)
export const resetPassword = async (values) => await api.post(RESET_PASSWORD, values)
export const logoutSession = async () => await api.post(LOGOUT)

// Profile
export const getMe = async () => await api.get(GET_PROFILE_DETAIL)
export const updateProfile = async (values) =>
  await api.post(UPDATE_PROFILE, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
export const updatePassword = async (values) => await api.post(UPDATE_PASSWORD, values)
